import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicWifiDetailsComponent } from './public-wifi-details/public-wifi-details.component';
import { AuB2B2EOnlyGuard } from '../guards/au-b2b2e-only.guard';
import { MyProximusAuthenticationCheckGuard } from '../guards/myproximus-authentication-check.guard';

const routes: Routes = [
  {
    path: 'public-wifi',
    component: PublicWifiDetailsComponent,
    canActivate: [MyProximusAuthenticationCheckGuard, AuB2B2EOnlyGuard],
    data: {
      analytics: {
        page: {
          name: 'myproducts overview',
          id: 'myproducts public wifi',
          category: {
            l1: 'myproximus',
            l2: 'myproducts',
            l3: 'public wifi',
          },
        },
      },
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicWifiRoutingModule {}
